// extracted by mini-css-extract-plugin
export default {"input":"AddHomeworkPerformanceForm_input__kJhxA","del":"AddHomeworkPerformanceForm_del__86Edt"};